import PurchaseApi from "../purchaseApi";
import { updateErrorMessage } from "../commonSlice";

const purchaseApi = PurchaseApi.injectEndpoints({
    endpoints: (builder) => ({
        CreateCheckout: builder.mutation({
            async queryFn(purchaseData, _queryApi, _extraOptions, fetchWithBQ) {
                try {
                    const response = await fetchWithBQ({
                        url: "/purchases-management/api/v1/products/checkouts",
                        method: "POST",
                        body: purchaseData,
                    });

                    if (response.error) {
                        _queryApi.dispatch(updateErrorMessage({
                            message: response.error.data?.msg || "Errore checkout",
                            type: "error",
                        }));
                        return { error: response.error };
                    }

                    _queryApi.dispatch(updateErrorMessage({
                        message: "Checkout creato",
                        type: "success",
                    }));

                    return { data: response.data };
                } catch (error) {
                    return { error: { status: 400, data: error } };
                }
            },
        }),
            }),
    overrideExisting: false,
});

export const {
    useCreateCheckoutMutation,
} = purchaseApi;
